export default __webpack_public_path__ + "static/hey-c47f2c4b76c6be9c3e3eb0c6727630da.png";